import styled from "styled-components";
import { theme } from "..";
export const HeaderMenuItem = styled.div `
  float: left;
  color: #444;
  height: ${theme.header.lineHeight};
  line-height: ${theme.header.lineHeight};
  padding: 0 10px;
  min-width: ${theme.header.lineHeight};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;

  :hover {
    color: "#444";
    background: rgba(0, 0, 0, 0.05);
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSGVhZGVyTWVudUl0ZW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY29tcG9uZW50cy9IZWFkZXJNZW51SXRlbS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsT0FBTyxNQUFNLE1BQU0sbUJBQW1CLENBQUM7QUFFdkMsT0FBTyxFQUFFLEtBQUssRUFBRSxNQUFNLElBQUksQ0FBQztBQUUzQixNQUFNLENBQUMsTUFBTSxjQUFjLEdBQUcsTUFBTSxDQUFDLEdBQUcsQ0FBQTs7O1lBRzVCLEtBQUssQ0FBQyxNQUFNLENBQUMsVUFBVTtpQkFDbEIsS0FBSyxDQUFDLE1BQU0sQ0FBQyxVQUFVOztlQUV6QixLQUFLLENBQUMsTUFBTSxDQUFDLFVBQVU7Ozs7Ozs7Ozs7OztDQVlyQyxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0ICogYXMgUmVhY3QgZnJvbSBcInJlYWN0XCI7XG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcInN0eWxlZC1jb21wb25lbnRzXCI7XG5cbmltcG9ydCB7IHRoZW1lIH0gZnJvbSBcIi4uXCI7XG5cbmV4cG9ydCBjb25zdCBIZWFkZXJNZW51SXRlbSA9IHN0eWxlZC5kaXZgXG4gIGZsb2F0OiBsZWZ0O1xuICBjb2xvcjogIzQ0NDtcbiAgaGVpZ2h0OiAke3RoZW1lLmhlYWRlci5saW5lSGVpZ2h0fTtcbiAgbGluZS1oZWlnaHQ6ICR7dGhlbWUuaGVhZGVyLmxpbmVIZWlnaHR9O1xuICBwYWRkaW5nOiAwIDEwcHg7XG4gIG1pbi13aWR0aDogJHt0aGVtZS5oZWFkZXIubGluZUhlaWdodH07XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG5cbiAgY3Vyc29yOiBwb2ludGVyO1xuXG4gIDpob3ZlciB7XG4gICAgY29sb3I6IFwiIzQ0NFwiO1xuICAgIGJhY2tncm91bmQ6IHJnYmEoMCwgMCwgMCwgMC4wNSk7XG4gIH1cbmA7XG4iXX0=